export default __webpack_public_path__ + "static/media/Naivedh's Resume.0b128fdb.pdf";